import React, { useContext, useRef } from "react";
import { ProjectContext } from "../../context/ProjectProvider";
import { createProjectAPI } from "../../utils/api";
import { ReactComponent as Logo } from "../../logo.svg";
import "./HeaderProject.css";

/** Encabezado de la lista de proyectos */
const HeaderProject = () => {
  const {
    /* proyectos */
    setProjects,
    loadProjectDetails,

    /* UI global */
    isProjectListCollapsed,
    setPdfColumnCollapsed,
    setCenterCollapsed,

    /* perfil */
    profile,

    /* flags de subida */
    isUploadingPdf,
    setUploadingPdf,
  } = useContext(ProjectContext);

  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    /* 🔒 Oculta inmediatamente la columna derecha mientras se sube */
    setPdfColumnCollapsed(true);
    setCenterCollapsed(true);

    setUploadingPdf(true);
    try {
      const { project } = await createProjectAPI({ name: file.name, file });
      setProjects((prev) => [...prev, project]);

      /* `loadProjectDetails` volverá a mostrar la columna derecha
         (el hook en PDFViewer restablece los flags al terminar) */
      await loadProjectDetails(project.id);
    } catch (err) {
      /* Si la subida falla, reabre la columna para no dejar la UI bloqueada */
      setPdfColumnCollapsed(false);
      setCenterCollapsed(false);

      alert(err.message);
      console.error(err);
    } finally {
      setUploadingPdf(false);
      e.target.value = "";
    }
  };

  return (
    <div
      className={`group-header project-header ${
        isProjectListCollapsed ? "collapsed" : ""
      }`}
    >
      <div className="header-left">
        <Logo className="project-logo" />
        <span>{profile?.company_name ?? ""}</span>
      </div>

      <button
        className={`icon-button project-new-btn ${
          isProjectListCollapsed ? "hidden" : ""
        }`}
        disabled={isUploadingPdf}
        onClick={() => fileInputRef.current?.click()}
      >
        {isUploadingPdf ? (
          <div className="spinner-border spinner-border-sm" role="status" />
        ) : (
          <>
            <i className="bi bi-file-earmark-plus" />
            <span className="button-tooltip">New project</span>
          </>
        )}
      </button>

      <input
        ref={fileInputRef}
        type="file"
        accept="application/pdf"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </div>
  );
};

export default HeaderProject;
